// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor5 from '@/game/prefabs/World/Mentors/Mentor5';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level25 extends TilemapScene {
  constructor() {
    super('Level25');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // tropical_biome_5
    const tropical_biome_5 = this.add.tilemap('tropical-biome-5');
    tropical_biome_5.addTilesetImage('tropical shores', 'tropical shores');
    tropical_biome_5.addTilesetImage(
      'tropical shores prefabs & samples',
      'tropical shores prefabs & samples',
    );
    tropical_biome_5.addTilesetImage(
      'tropical shores, just trees',
      'tropical shores, just trees',
    );
    tropical_biome_5.addTilesetImage('collision');

    // terrain_1
    tropical_biome_5.createLayer('terrain', ['tropical shores'], 0, 0);

    // dirt_path_1
    tropical_biome_5.createLayer(
      'dirt path',
      ['tropical shores prefabs & samples'],
      0,
      0,
    );

    // underwater_1
    tropical_biome_5.createLayer(
      'underwater',
      ['tropical shores prefabs & samples'],
      0,
      0,
    );

    // cliffs_1
    tropical_biome_5.createLayer('cliffs', ['tropical shores'], 0, 0);

    // deco_1
    tropical_biome_5.createLayer('deco', ['tropical shores'], 0, 0);

    // water_1
    tropical_biome_5.createLayer(
      'water',
      ['tropical shores prefabs & samples'],
      0,
      0,
    );

    // land_overlapping_water_1
    tropical_biome_5.createLayer(
      'land overlapping water',
      ['tropical shores'],
      0,
      0,
    );

    // tOP_cliff_edges_1
    tropical_biome_5.createLayer('TOP cliff edges', ['tropical shores'], 0, 0);

    // tOP_trees_1
    tropical_biome_5.createLayer(
      'TOP trees',
      ['tropical shores, just trees'],
      0,
      0,
    );

    // cOLLISION_1
    const cOLLISION_1 = tropical_biome_5.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 864, 656);
    this.add.existing(player);

    // worldNode
    const worldNode = new WorldNode(this, 800, 448);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 688, 304);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 664, 88);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 464, 168);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 248, 256);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 208, 472);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 192, 736);
    this.add.existing(portal);

    // forestTree1
    const forestTree1 = new ForestTree1(
      this,
      936,
      608,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(
      this,
      920,
      736,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      824,
      576,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      1000,
      560,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      984,
      464,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      968,
      448,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      888,
      384,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      872,
      368,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      792,
      288,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      520,
      224,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      440,
      272,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      408,
      304,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      376,
      288,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      360,
      320,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      104,
      304,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      136,
      416,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      392,
      432,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      280,
      512,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      248,
      624,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      136,
      672,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      200,
      704,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      120,
      768,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      264,
      736,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      248,
      784,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      264,
      832,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(
      this,
      152,
      768,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(
      this,
      152,
      688,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(
      this,
      296,
      576,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(
      this,
      776,
      304,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(
      this,
      888,
      512,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(
      this,
      920,
      496,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(
      this,
      920,
      528,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(
      this,
      984,
      592,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_31);

    // forestTree_32
    const forestTree_32 = new ForestTree1(
      this,
      312,
      320,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_32);

    // forestTree_33
    const forestTree_33 = new ForestTree1(
      this,
      808,
      640,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_33);

    // forestTree_34
    const forestTree_34 = new ForestTree1(
      this,
      728,
      480,
      'tropical shores, just trees',
      1,
    );
    this.add.existing(forestTree_34);

    // forestTree_35
    const forestTree_35 = new ForestTree1(
      this,
      552,
      240,
      'tropical shores, just trees',
      1,
    );
    this.add.existing(forestTree_35);

    // forestTree_36
    const forestTree_36 = new ForestTree1(
      this,
      216,
      376,
      'tropical shores, just trees',
      1,
    );
    this.add.existing(forestTree_36);

    // forestTree_37
    const forestTree_37 = new ForestTree1(
      this,
      648,
      232,
      'tropical shores, just trees',
      9,
    );
    this.add.existing(forestTree_37);

    // forestTree_38
    const forestTree_38 = new ForestTree1(
      this,
      680,
      200,
      'tropical shores, just trees',
      9,
    );
    this.add.existing(forestTree_38);

    // forestTree_39
    const forestTree_39 = new ForestTree1(
      this,
      712,
      216,
      'tropical shores, just trees',
      9,
    );
    this.add.existing(forestTree_39);

    // forestTree_40
    const forestTree_40 = new ForestTree1(
      this,
      680,
      256,
      'tropical shores, just trees',
      9,
    );
    this.add.existing(forestTree_40);

    // forestTree_41
    const forestTree_41 = new ForestTree1(
      this,
      744,
      256,
      'tropical shores, just trees',
      9,
    );
    this.add.existing(forestTree_41);

    // mentor
    const mentor = new Mentor5(this, 800, 696);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 192, 592);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 296, 368);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 904, 384);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 928, 624);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 24;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 24;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 24;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 24;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 24;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 24;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 24;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 24;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 24;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 24;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.tropical_biome_5 = tropical_biome_5;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor5;
  private tropical_biome_5!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.tropical_biome_5,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
